import { injectPtElectricWireCSS } from '../../css/pt-electric/ptElectricWireCss';
import { ElectricStatus } from '../../constants/ElectricStatus';

injectPtElectricWireCSS();

export default {
	model: {
		status: {
			type: 'list',
			format: [
				ElectricStatus.ENERGIZED,
				ElectricStatus.DEENERGIZED,
				ElectricStatus.DC_ENERGIZED,
				ElectricStatus.AC_ENERGIZED
			],
			default: ElectricStatus.DEENERGIZED,
			bind: {
				to: 'attr',
				name: 'data-status'
			}
		}
	},
	listeners: {
		click: true,
		contextmenu: true,
		mouseenter: true,
		mouseleave: true
	}
};

